import DiscoveryFilters from "./DiscoveryFilters/DiscoveryFilters";
import Text from "components/Text/Text";
import "./styles.scss"
import StoreCard from "./StoreCard/StoreCard";
import { IStoreDiscovery } from "types/services";
import { useSubscription, useUser } from "hooks/user";
import { PlanType } from "enum/planTypes";
import { ROLES } from "enum/roles";
import LockedStoreCard from "./StoreCard/LockedStoreCard";
import { useGetStoreDiscovery } from "hooks/stores";
import { useEffect, useState } from "react";
import InfiniteScroll from 'react-infinite-scroll-component';
import StoreSkeletonCard from "./StoreCard/StoreSkeletonCard"
import { BiLock } from "react-icons/bi";
import StoreModal from "./StoreModal/StoreModal";
import { Select } from "antd";

const StoreDiscoveryInner = () => {

    const { subscription } = useSubscription();
    const { user } = useUser();
    const [searchBtn, setSearchBtn] = useState(false)
    const [isModalVisible, setIsModalVisible] = useState(false);

    const [searchFilters, setSearchFilters] = useState({
        searchQuery: "",
        minReviews: "",
        maxReviews: "",
        minRating: "",
        maxRating: "",
        minOrders: "",
        maxOrders: "",
        sortBy: "",
        skip: 0,
        limit: 24,
        origin: "PK"
    })
    const { Option } = Select;

    const sortFilter: { [key: string]: string } = {
        match: "Best Match",
        topSale: "Top Sale",
    };
    const [discoveryStores, setDiscoveryStores] = useState<IStoreDiscovery[]>([])
    const [activeFilters, setActiveFilters] = useState(searchFilters);
    const [selectedStore, setSelectedStore] = useState<number>(0)
    const [hasMore, setHasMore] = useState(true)
    const { stores, total, isLoading } = useGetStoreDiscovery({ 
        ...activeFilters 
    });    
    let userLocked = false;
    if( user?.role === ROLES.SUPER_ADMIN || 
        (subscription?.planType !== PlanType.FREE && subscription?.remainingDays) || (subscription?.planType === PlanType.LIFETIME)) {
        userLocked = false
    } else {
        userLocked = true
    }
    let totalStores = userLocked ? 24 : total || 0
    let endMessage = userLocked ? <span className="lockerEnd"><BiLock size={20} /> <span>Upgrade your plan to discover more stores insights</span></span> : "No more data found"

    const handleSearchFilters = (values: any) => {
        setSearchFilters(prevFilters => ({
            ...prevFilters,
            ...values
        }));
    };


    const handleStoreSearch = () => {
        setSearchBtn(false)
        setDiscoveryStores([])
        setActiveFilters(searchFilters); // Update the active filters to trigger fetch
    }

    useEffect(() => {
        if(searchBtn) handleStoreSearch()
    }, [searchBtn])

    const fetchMoreData = () => {
        if(discoveryStores.length && !userLocked) setActiveFilters({...searchFilters, skip: discoveryStores.length}); // Update the active filters to trigger fetch
    };
    useEffect(() => {
        if (stores?.length) {
            setDiscoveryStores([...discoveryStores, ...stores])
        }
        if(stores?.length === Number(totalStores)) {
            setHasMore(false)
        } else {
            setHasMore(true)
        }
        if(userLocked)
            setHasMore(false)

    }, [stores])

    const handleSortByFilter = (filter: string) => {
        handleSearchFilters({...activeFilters, 'sortBy': filter})
        setSearchBtn(false)
        setDiscoveryStores([])
        setActiveFilters({...activeFilters, 'sortBy': filter});
    }
    const handleQuickView = (shopId: number) => {
        setSelectedStore(shopId)
        setIsModalVisible(true);
    };

    const handleModalClose = () => {
        setIsModalVisible(false);
    };
    const resetFiltersHandler = () => {
        const emptyFilters = {
            searchQuery: "",
            minReviews: "",
            maxReviews: "",
            minRating: "",
            maxRating: "",
            minOrders: "",
            maxOrders: "",
            sortBy: "",
            skip: 0,
            limit: 24,
            origin: ""
        };
        setSearchFilters(emptyFilters);
        setActiveFilters(emptyFilters);
    }
    function extractBaseUrl(url: string) {
        const regex = /^\/\/([^\/]+)/;
        const match = url.match(regex);
        if (match && match[1]) {
            return match[1];
        }
        return null;
    }
    const redirectToStoreDetails = (storeUrl:string, itemId: number) => {
        const baseUrl = extractBaseUrl(storeUrl);
        return 'https://'+baseUrl+'/i'+itemId + '.html'
    }
    return (
        <>
        <div id="storeList">
            <Text type={"h1"} className="page-title">Store Discovery</Text>
            <DiscoveryFilters setSearchBtn={setSearchBtn} searchFilters={activeFilters} handleSearchFilters={handleSearchFilters} resetFiltersHandler={resetFiltersHandler} />
            <div className="result-wrapper">
                <h3 className="text-left">{total ? `Stores Found: ${total}` : ""}</h3>
                <div>
                    <label className="sort-by-label">Sort By:</label>
                    <Select
                        defaultValue={activeFilters.sortBy}
                        placeholder="Sort By"
                        className="sort-filter"
                        filterOption={false}
                        onChange={(value) => handleSortByFilter(value)}
                    >
                        {Object.keys(sortFilter).map((key) => (
                            <Option key={key} value={key}>
                                {sortFilter[key]}
                            </Option>
                        ))}
                    </Select>
                </div>
                
            </div>
            <div className="store-list">
                    <InfiniteScroll
                        dataLength={totalStores}
                        className="infinite-scroll"
                        next={fetchMoreData}
                        loader={<StoreSkeletonCard />}
                        endMessage={
                            <p className="noMoreData">
                                <b>{endMessage}</b>
                            </p>
                        }
                        hasMore={hasMore}
                        scrollableTarget="contentContainer"
                    >
                        {discoveryStores?.map((store:IStoreDiscovery, index: any) => (
                            !userLocked ||
                            (userLocked && index < 4)
                            ? (
                                <StoreCard key={index} store={store} handleQuickView={handleQuickView} storeUrl={store.storeUrl} />
                            )
                            : (
                                <LockedStoreCard key={index} />
                            )
                        ))}
                    </InfiniteScroll>
            </div>
        </div>
        {selectedStore ? (
            <StoreModal 
                itemId={selectedStore} 
                isVisible={isModalVisible} 
                onClose={handleModalClose} 
            />
        ) : <></>}
        </>
    )
}

export default StoreDiscoveryInner